import { tv } from 'tailwind-variants';

export const inputStyle = tv({
  slots: {
    container: `
      relative
      rounded-md
      shadow-sm
    `,
    helperText: `
      mt-2
      text-xs
      font-light
      text-neutral-500
    `,
    input: `
      block
      w-full
      rounded-md
      border-0
      bg-white
      px-3
      py-2
      text-left
      text-sm
      leading-6
      text-neutral-900
      ring-1
      ring-neutral-200
      placeholder:text-neutral-500
      focus:ring-2
      focus:ring-neutral-950/50
    `,
    inputLoader: `
      pointer-events-none
      absolute
      right-3
      top-1/2
      hidden
      size-5
      -translate-y-1/2
    `,
    inputLoaderIcon: `
      size-full
      animate-spin
      text-gray-400
    `,
    inputRight: `
      pointer-events-none
      absolute
      right-3
      top-1/2
      size-5
      -translate-y-1/2
    `,
    inputLeft: `
      pointer-events-none
      absolute
      left-3
      top-1/2
      size-5
      -translate-y-1/2
    `,
    inputIcon: `
      size-4
      text-neutral-400
    `,
  },
  variants: {
    loading: {
      true: {
        input: 'pr-10',
        inputRight: 'hidden',
        inputLoader: 'block',
      },
    },
    inline: {
      true: {
        container: `
          shadow-none
        `,
        input: `
          py-2
          text-base
          ring-0
          ring-gray-300
          hover:ring-1
        `,
      },
    },
    error: {
      true: {
        input: `
          ring-red-400
          focus:ring-red-400
        `,
        helperText: `
          font-medium
          text-red-400
        `,
      },
    },
    disabled: {
      true: {
        input: `text-gray-400 ring-gray-300`,
        inputIcon: `text-gray-300`,
      },
    },
    withLeft: {
      true: {
        input: 'pl-10',
      },
    },
    withRight: {
      true: {
        input: 'pr-10',
      },
    },
  },
  compoundVariants: [
    { inline: true, disabled: true, className: { input: 'hover:ring-0' } },
  ],
});
